import { makeStyles } from '@material-ui/styles';
import city from './images/city.png';
import cityWeb from './images/cityWeb.png';
import cloud from './images/cloud.svg';
import cloud2 from './images/cloud2.svg';

export default makeStyles(theme => ({
  container: {
    overflow: 'hidden',
  },
  sectionFirst: {
    height: 451,
    position: 'relative',

    '&::before': {
      content: '""',
      display: 'block',
      width: '100%',
      height: '100%',
      background: theme.palette.colors.divider,
      transformOrigin: `bottom left`,
      transform: `skewY(-16deg)`,
      position: `absolute`,
      zIndex: 1,
    },

    [theme.breakpoints.up('md')]: {
      height: 370,
      '&::before': {
        transform: `skewY(-11deg)`,
      },
    },

    [theme.breakpoints.up('lg')]: {
      height: '100vh',
    },
  },
  sectionSecond: {
    height: 360,

    [theme.breakpoints.up('md')]: {
      height: 390,
    },

    [theme.breakpoints.up('lg')]: {
      height: '100vh',
    },
  },
  sectionThird: {
    height: 500,
    position: 'relative',
    backgroundColor: theme.palette.colors.oxfordBlue,

    '&::before': {
      content: '""',
      display: 'block',
      width: '100%',
      height: '100%',
      background: theme.palette.colors.oxfordBlue,
      transformOrigin: `left`,
      transform: `skewY(-16deg)`,
      position: `absolute`,
      zIndex: 1,
    },

    '&::after': {
      content: '""',
      display: 'block',
      width: '100%',
      height: '100%',
      position: 'absolute',
      bottom: 0,
      zIndex: 2,
      backgroundImage: `url(${city}), url(${cloud}), url(${cloud}), url(${cloud2})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom, top right 10%, top 16% right 30%, bottom 180px left 10%',
      backgroundSize: `919px 146px, 105px 42px, 78px 31px, 87px 24px`,
    },

    [theme.breakpoints.up('md')]: {
      height: 600,
      '&::after': {
        backgroundPosition: 'bottom left -10px, top right 10%, top 16% right 30%, bottom 180px left 10%',
      },
      '&::before': {
        transform: `skewY(-11deg)`,
      },
    },

    [theme.breakpoints.up('lg')]: {
      height: '100vh',

      '&::after': {
        backgroundImage: `url(${cityWeb}), url(${cloud}), url(${cloud}), url(${cloud2})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom right, top right 20%, top 15% right 5%, top 202px right 50%',
        backgroundSize: `auto 36vh, 183px 72px, 136px 54px, 188px 53px`,
      },
    },
  },
  sectionContent: {
    position: 'relative',
    zIndex: 3,
    height: 'inherit',
    padding: [0, 28],

    [theme.breakpoints.up('md')]: {
      padding: [0, 70],
      display: 'flex',
      justifyContent: 'space-between',
    },

    [theme.breakpoints.up('lg')]: {
      maxWidth: 1690,
      margin: [0, 'auto'],
    },
  },
  sectionFirstContent: {
    [theme.breakpoints.up('md')]: {
      paddingTop: 147,
    },

    [theme.breakpoints.up('lg')]: {
      paddingTop: '36vh',
    },
  },
  sectionSecondContent: {
    paddingTop: 40,
    [theme.breakpoints.up('md')]: {
      paddingTop: 81,
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },

    [theme.breakpoints.up('lg')]: {
      paddingTop: '17vh',
    },
  },
  sectionThirdContent: {
    [theme.breakpoints.up('md')]: {
      paddingTop: 81,
      alignItems: 'flex-end',
    },

    [theme.breakpoints.up('lg')]: {
      paddingTop: 67,
    },
  },
  sectionImage: {
    position: 'absolute',
    top: 0,
    right: 0,

    [theme.breakpoints.up('md')]: {
      position: 'relative',
      top: 'unset',
      right: 'unset',
    },
  },
  sectionFirstImage: {
    top: 72,

    [theme.breakpoints.up('md')]: {
      top: 'unset',
      height: 221,
    },

    [theme.breakpoints.up('lg')]: {
      height: '57vh',
    },
  },
  sectionSecondImage: {
    bottom: 0,
    left: 12,
    top: 'unset',
    right: 'unset',

    [theme.breakpoints.up('md')]: {
      height: 264,
      left: -8,
    },

    [theme.breakpoints.up('lg')]: {
      height: '52vh',
      left: 110,
    },
  },
  sectionThirdImage: {
    bottom: 0,
    top: 'unset',

    [theme.breakpoints.up('md')]: {
      marginBottom: -7,
      height: 368,
    },

    [theme.breakpoints.up('lg')]: {
      height: '70vh',
    },
  },
  title: {
    color: theme.palette.colors.indigoDye,
    fontSize: theme.spacing(3),
    textAlign: 'center',
    paddingTop: 40,
    marginBottom: 88,

    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%)',
      top: 0,
      marginBottom: 0,
    },

    [theme.breakpoints.up('lg')]: {
      fontSize: 36,
      paddingTop: '19vh',
    },

    [theme.breakpoints.up('xl')]: {
      fontSize: 48,
    },
  },
  pageNav: {
    display: 'none',

    [theme.breakpoints.up('lg')]: {
      display: 'block',
      transform: 'rotate(-90deg)',
      transformOrigin: 'left',
      position: 'absolute',
      bottom: '19vh',
    },
  },
  pageNavWithBigSpaceBottom: {
    [theme.breakpoints.up('lg')]: {
      bottom: '36vh',
    },
  },
  sectionNumber: {
    color: theme.palette.colors.border,
    fontSize: 90,
    fontWeight: 800,
    marginLeft: -theme.spacing(1),

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(6),
      lineHeight: '85%',
    },

    [theme.breakpoints.up('lg')]: {
      fontSize: 255,
      marginLeft: -theme.spacing(2),
    },

    [theme.breakpoints.up('xl')]: {
      fontSize: 300,
    },
  },
  sectionSecondNumber: {
    position: 'absolute',
    top: -theme.spacing(3),
    right: 22,

    [theme.breakpoints.up('md')]: {
      top: 81,
      right: 70,
    },

    [theme.breakpoints.up('lg')]: {
      top: '12vh',
      right: 183,
    },
  },
  sectionTitle: {
    color: theme.palette.colors.darkBlue,

    [theme.breakpoints.up('lg')]: {
      fontSize: theme.spacing(3),
    },

    [theme.breakpoints.up('xl')]: {
      fontSize: theme.spacing(4),
      lineHeight: '40px',
    },
  },
  sectionDescription: {
    color: theme.palette.colors.darkBlue,
    margin: [theme.spacing(2), 0],
    fontSize: 12,

    [theme.breakpoints.up('lg')]: {
      fontSize: 18,
      margin: [theme.spacing(4), 0],
    },

    [theme.breakpoints.up('xl')]: {
      fontSize: theme.spacing(3),
      lineHeight: '31px',
      margin: [theme.spacing(4), 0],
    },
  },
  light: {
    color: theme.palette.colors.white,
  },
  text: {
    [theme.breakpoints.up('lg')]: {
      marginLeft: 120,
    },
  },
  sectionThirdText: {
    [theme.breakpoints.up('md')]: {
      alignSelf: 'flex-start',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Description/useStyles.js